export const ORPHAN_SENTINEL_ID = -7;

export const isOrphanId = (id) => id === undefined || id === null || id === ORPHAN_SENTINEL_ID;

export const displayIdOrOrphan = (id) => (isOrphanId(id) ? "—" : id);
